import _defineProperty from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "color", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
var baseIcon = function baseIcon(iconTitle, hex, iconPath) {
  return React.forwardRef(function (_ref, ref) {
    var _ref$title = _ref.title,
      title = _ref$title === void 0 ? iconTitle : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      others = _objectWithoutProperties(_ref, _excluded);
    if (color === "default") {
      color = hex;
    }
    return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref: ref
    }, others), {}, {
      children: [/* @__PURE__ */jsx("title", {
        children: title
      }), /* @__PURE__ */jsx("path", {
        d: iconPath
      })]
    }));
  });
};
var baseIcon$1 = baseIcon;
export { baseIcon$1 as default };